import { render } from "./Guides.vue?vue&type=template&id=037f9471&scoped=true"
import script from "./Guides.vue?vue&type=script&lang=js"
export * from "./Guides.vue?vue&type=script&lang=js"

import "./Guides.vue?vue&type=style&index=0&id=037f9471&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037f9471"]])

export default __exports__